/* eslint-disable tailwindcss/no-custom-classname */
/* eslint-disable tailwindcss/no-arbitrary-value */
'use client';
import classNames from 'classnames';
import { useState } from 'react';
import { BaseTranslations } from '../baseTranslations';
import { CmsOffer } from '../types/cmsProduct';
import { useCmsClientContext } from '../utils/cmsPageContext';
import { getClientTranslations } from '../utils/translations/getClientTranslations';
import { tr } from '../utils/translations/tr';
import { MaterialIcon } from './MaterialIcon';
import { RichText } from './RichText';
import { Tag } from './Tag';

export const ProductCardOffer: React.FC<CmsOffer> = ({
  type,
  uid,
  offer_title,
  description,
  introduction,
  list_of_gifts,
}) => {
  const context = useCmsClientContext();
  const staticText = getClientTranslations(BaseTranslations, context);
  const [termsVisible, setTermsVisible] = useState(false);

  return (
    <div className="rounded-2xl px-padding/x py-padding/y bg-white xl:rounded-3xl">
      <div className="mb-2">
        <Tag color={type === 'exclusive' ? 'blue' : 'gray'}>{offer_title}</Tag>
      </div>
      {introduction && (
        <p
          className="mb-2" // rich-description
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: introduction }}
        />
      )}
      <h5 className="mb-1 !font-bold text-gray-800 alpha-body-2 md:mb-2">
        {tr('offers', staticText)}
      </h5>
      <ul className="ml-2 list-disc px-padding/x !font-bold text-gray-800 alpha-body-2">
        {list_of_gifts?.map((gift, index) => (
          <li id={`#gift_${gift?.id}_${uid}`} key={gift?.id} className="mb-2">
            {gift?.criteria_list && gift.criteria_list.length > 0 ? (
              <>
                <div>
                  {gift.criteria_list
                    .filter((c) => !!c)
                    .map((criteria, criteriaIndex) => (
                      <span key={criteria.label} className="inline">
                        <span>{criteria.label}</span>:
                        <span>
                          {criteria.starting_point_label} {criteria.prefix}
                          {criteria.value_start}
                          {!criteria.ending_point_label ? (
                            <span>{criteria.suffix}</span>
                          ) : (
                            <span>
                              {criteria.ending_point_label} {criteria.prefix}
                              {criteria.value_end}
                              {criteria.suffix}
                            </span>
                          )}
                        </span>
                        {criteriaIndex < gift.criteria_list!.length - 1 && (
                          <span> +&nbsp;</span>
                        )}
                      </span>
                    ))}
                </div>
                <ul className="ml-2 list-disc px-padding/x text-gray-800 alpha-body-2">
                  <li className="font-bold">
                    {gift.gift?.gift_title}
                    {index < list_of_gifts.length - 1 && `; ${staticText.or} `}
                  </li>
                </ul>
              </>
            ) : (
              <span>
                {gift?.gift?.gift_title}
                {index < list_of_gifts.length - 1 && `; ${staticText.or} `}
              </span>
            )}
          </li>
        ))}
      </ul>

      {description && (
        <div className="mt-4 rounded-2xl px-padding/x py-padding/y bg-gray-200 md:mt-6 xl:rounded-3xl">
          <button
            type="button"
            className="flex w-full cursor-pointer items-center justify-between"
            onClick={() => setTermsVisible(!termsVisible)}
            aria-expanded={termsVisible}
            aria-controls="terms-content"
          >
            <div className="flex items-center">
              <h5 className="!font-semibold text-gray-700 alpha-body-2">
                {staticText.terms_and_conditions}
              </h5>
            </div>

            <MaterialIcon
              icon="expand_less"
              className={`transition-transform ${termsVisible ? 'rotate-0' : 'rotate-180'}`}
            />
          </button>
          <RichText
            id="terms-content"
            className={classNames(
              { hidden: !termsVisible },
              'prose mt-1 max-w-full text-gray-800 alpha-body-2 md:mt-2 [&>ul]:ml-2 [&>ul]:pl-6 [&_a]:underline [&_a]:text-[--text-link]',
            )}
          >
            {description}
          </RichText>
        </div>
      )}
    </div>
  );
};
